import { makeStyles } from "makeStyles";
import { AppRole } from "../models";
import { Box, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { permissionsTableStyles } from "../styles";
import { useState, useMemo } from "react";
import { TableSortOrder, getComparator, SimpleSortableTableHeadProps, SortableTableHead } from "../SortableTableHead";

const useStyles = makeStyles()((theme) => ({
  ...permissionsTableStyles(theme)
}));

interface Props {
  permissions?: AppRole[];
}

const GroupsPermissions: React.FunctionComponent<Props> = (props) => {
  const { classes } = useStyles();

  const [order, setOrder] = useState<TableSortOrder>("asc");
  const [orderBy, setOrderBy] = useState<keyof AppRole>("identifier");

  const handleRequestSort = (event: React.MouseEvent<unknown>, property: keyof AppRole) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const displayRows = useMemo(
    () => [...(props.permissions ?? [])].sort(getComparator(order, orderBy)),
    [order, orderBy, props.permissions]
  );

  function GroupsPermissionsTableHead({ id, label, className }: SimpleSortableTableHeadProps<AppRole>) {
    return (
      <SortableTableHead
        className={className}
        headCell={{
          id,
          label
        }}
        order={order}
        orderBy={orderBy}
        onRequestSort={handleRequestSort}
      />
    );
  }

  return (
    <Box className={classes.childTableContainer}>
      <Table size="small" className={classes.borderedTable}>
        <TableHead>
          <TableRow>
            <GroupsPermissionsTableHead id="identifier" label="Identifier" />
            <GroupsPermissionsTableHead id="displayName" label="Display Name" />
            <GroupsPermissionsTableHead id="description" label="Description" />
          </TableRow>
        </TableHead>
        <TableBody>
          {displayRows?.map((permission) => (
            <TableRow key={permission.id}>
              <TableCell>{permission.identifier}</TableCell>
              <TableCell>{permission.displayName}</TableCell>
              <TableCell>{permission.description}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

export default GroupsPermissions;
